import axios from 'axios';

function normalizeResponse(data) {
    return {
        ...data,
        Ok: data.Ok !== undefined ? data.Ok : data.ok,
        Dados: data.Dados !== undefined ? data.Dados : data.dados,
        Token: data.Token !== undefined ? data.Token : data.token,
        Mensagem: data.Mensagem || data.mensagem || data.error,
        success: data.success !== undefined ? data.success : data.ok,
        message: data.message || data.token || data.mensagem || data.error
    };
}

function requestConfig(headers) {
    if (!headers) return undefined;
    return headers.headers ? headers : { headers };
}

export async function Get(url, headers) {

    if (headers !== null && headers !== undefined) {
        return await axios.get(url, requestConfig(headers)).then(response => {
            return normalizeResponse(response.data);
        }).catch(error => {
            return error;
        });
    }
    else {
        return await axios.get(url).then(response => {
            return normalizeResponse(response.data);
        }).catch(error => {
            return error;
        });
    }
}


export async function GetComToken(url, headers) {
    try {
        if (headers !== null && headers !== undefined) {
            const response = await axios.get(url, { headers: headers }); // Corrigido: headers dentro de um objeto
            return normalizeResponse(response.data);
        } else {
            const response = await axios.get(url);
            return normalizeResponse(response.data);
        }
    } catch (error) {
        return error;
    }
}

export async function Post(url, body, headers) {
    if (headers !== null && headers !== undefined) {
        return await axios.post(url, body, requestConfig(headers)).then(response => {
            return normalizeResponse(response.data);
        }).catch(error => {
            return error;
        });
    }
    else {
        return await axios.post(url, body).then(response => {
            return normalizeResponse(response.data);
        }).catch(error => {
            return error;
        });
    }
}

export async function Put(url, body, headers) {
    if (headers !== null && headers !== undefined) {
        return await axios.put(url, body, requestConfig(headers)).then(response => {
            return normalizeResponse(response.data);
        }).catch(error => {
            return error;
        });
    }
    else {
        return await axios.put(url, body).then(response => {
            return normalizeResponse(response.data);
        }).catch(error => {
            return error;
        });
    }
}

export async function Delete(url, headers) {
    if (headers !== null && headers !== undefined) {
        return await axios.delete(url, requestConfig(headers)).then(response => {
            return normalizeResponse(response.data);
        }).catch(error => {
            return error;
        });
    }
    else {
        return await axios.delete(url).then(response => {
            return normalizeResponse(response.data);
        }).catch(error => {
            return error;
        });
    }
}